import { Modal } from 'react-bootstrap';
import React, { useMemo } from 'react';
import PicabooModal from './PicabooModal';
import styles from './StepModal.less';
import MaterialIcon from './MaterialIcon';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import { useSelector } from 'react-redux';
import { savingSelector } from '../ducks/changesets';

export default ({
  steps,
  currentStep,
  nextStepHandler,
  previousStepHandler,
  backDisabled = false,
  nextDisabled = false,
  close,
  show,
}) => {
  const { t } = useTranslation();
  if (!steps || !steps[currentStep]) {
    return;
  }
  let step = steps[currentStep];
  if (!step) {
    return;
  }

  const saving = useSelector(savingSelector);

  const loading = useMemo(() => {
    // Show a loading state if the project is currently saving AND we're on the confirm project step.
    // This ensures the customer sees the final price, and mitigates "saving" toggling between true and false during later steps.
    if (saving && currentStep === 1) {
      return true;
    }
    return false;
  }, [saving, currentStep]);

  return (
    <PicabooModal
      scrollable={true}
      dialogStyle={styles.largeModal}
      show={show}
      onHide={close}
    >
      <Modal.Header>
        <Modal.Title>{steps[currentStep].title}</Modal.Title>
        <ul className={styles.progressSteps}>
          {steps.map((step, stepNumber) => {
            return (
              <li
                key={stepNumber}
                className={
                  stepNumber < currentStep
                    ? styles.past
                    : stepNumber === currentStep
                      ? styles.present
                      : ''
                }
              >
                {step.title}
                <MaterialIcon
                  icon={
                    stepNumber < currentStep
                      ? 'check_circle'
                      : stepNumber === currentStep
                        ? 'brightness_1'
                        : 'trip_origin'
                  }
                />
              </li>
            );
          })}
        </ul>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.stepContent}>{step.content}</div>
      </Modal.Body>
      {currentStep != steps.length - 1 && (
        <Modal.Footer>
          <div className={styles.actions}>
            <Button variant="tertiary" onClick={close} width="auto">
              {t('STEPMODAL.Cancel')}
            </Button>
            <Button
              variant="secondary"
              onClick={previousStepHandler}
              width="182px"
              disabled={backDisabled}
            >
              {t('STEPMODAL.Back')}
            </Button>
            <Button
              variant="primary"
              onClick={nextStepHandler}
              width="182px"
              loading={loading}
              disabled={nextDisabled}
            >
              {t('STEPMODAL.Next')}
            </Button>
          </div>
        </Modal.Footer>
      )}
    </PicabooModal>
  );
};
